import axios from "axios";
import { config } from "@/config/constants.js";
import genericStore from "../generic_store";
export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "videos",
    object: "video",
    header: [
      { text: "ID", value: "id" },
      { text: "Name", value: "name" },
      { text: "Picture", value: "picture" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    list: [],
    total: 0,
  },
  mutations: {
    ...genericStore.mutations,
    success(state, data) {
      state.status = "success";

      if (data && data["list"]) {
        state.list = data["list"];
      }
      if (data && data["total"]) {
        state.total = data["total"];
      }
    },
  },
  actions: {
    ...genericStore.actions,
    get_videos({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");
        let filter = {
          ...options
          /* search: ""*/
        };
        axios
          .get(config.api_url + "videos", {
            params: filter
          })
          .then(response => {
            commit("success", {
              list: response.data,
              total: parseInt(
                response.headers["pagination-count"]
              )
            });
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
